<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <label class="col-form-label text-primary">Saldo Total:</label>
                </div>
                <div class="col-auto">
                   <input type="text" class="form-control" readonly :value="$formatNumber(SaldoGeneral,'$')">
                </div>
            </template>
			
            
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre</th>
                <th :class="StyleTh">Clave</th>
                <th :class="StyleTh">Email</th>
                <th :class="StyleTh">Cargo</th>
                
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					<td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                    <td><p :class="StyleTd">{{lista.Clave}}</p></td>
                    <td><p :class="StyleTd">{{ $limitCharacters(lista.Email,38)}}</p></td>
                    <td class="text-end"><h6 :class="StylePr">{{ $formatNumber(lista.Cargo,'$') }}</h6></td>
                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="false" :pShowBtnDelete="false" :pIsModal="true" :pId="lista.IdCargoCliente" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                                <button @click="AbrirDetalle(lista.IdCliente)" title="Ver Facturas" class="btn btn-link text-primary px-3 mb-0 mr-1">
                                    <i class="far fa-eye fa-lg text-primary me-2" aria-hidden="true"></i>
                                    
                                </button>
                            </template>
						</CBtnAccion>
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="6"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Detalle :poBtnSave="oBtnSave"></Detalle>
			</template>
		</CModal>
	</div>
</template>

<script>

import moment from 'moment';
import Detalle from './ListDetalle.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionClientePago';

export default {
    name: 'ListaClientePago',
    props: ['sFiltros','pOrigen'],
    components: {
        Detalle
    },
    data() {
        return {
            ConfigList:{
                Title: 'Facturas del Cliente',
                IsModal: true,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: false,
                BtnNewShow: false,
                TitleFirst: '',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Listado de Facturas",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize: 'xl'
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            SaldoGeneral:0
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("clientepagoclientes",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                //this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        AbrirDetalle(Id){
            this.bus.$emit('NewModal_'+this.ConfigModal.EmitSeccion,Id);  
        },
        GetSaldoGeneral(){
            this.$http.get('getsaldogeneral').then((res)=>{
                this.SaldoGeneral=res.data.data.Total;
            });
        }
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.bus.$off('List_'+EmitEjecuta);
        this.GetSaldoGeneral();
    },
    mounted()
    {
        this.Lista();

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });
    }
}
</script>
